import request from '@/utils/request'

export function listQuotes(data) {
  return request({
    url: '/crmQuote/list',
    method: 'post',
    data
  })
}

export function getQuoteDetail(id) {
  return request({
    url: `/crmQuote/detail/${id}`,
    method: 'get'
  })
}

export function listQuoteTemplates() {
  return request({
    url: '/crmQuote/template/list',
    method: 'get'
  })
}

export function getQuoteTemplateDetail(templateCode) {
  return request({
    url: `/crmQuote/template/detail/${templateCode}`,
    method: 'get'
  })
}

export function getDefaultEquipmentTemplate() {
  return request({
    url: '/crmQuote/template/defaultEquipment',
    method: 'get'
  })
}

export function calculateQuote(data) {
  return request({
    url: '/crmQuote/calculate',
    method: 'post',
    data
  })
}

export function saveQuote(data) {
  return request({
    url: '/crmQuote/save',
    method: 'post',
    data
  })
}

export function confirmQuote(id) {
  return request({
    url: `/crmQuote/confirm/${id}`,
    method: 'post'
  })
}

export function submitQuoteSealApproval(data) {
  return request({
    url: '/crmQuote/sealApproval',
    method: 'post',
    data
  })
}

export function convertQuoteContract(data) {
  return request({
    url: '/crmQuote/convertContract',
    method: 'post',
    data
  })
}

export function removeQuote(id) {
  return request({
    url: `/crmQuote/remove/${id}`,
    method: 'post'
  })
}
